import PropTypes from 'prop-types';
import React from 'react';
import Sop from 'views/Sop';
import { isDefined } from '@acheloisbiosoftware/absui.utils';

const pageContainerProps = { sx: { borderRadius: 0 }};

function SopsContent(props) {
  const { selected } = props;
  return !isDefined(selected) ? null : (
    <Sop
      id={selected}
      pageContainerProps={pageContainerProps}
    />
  );
}

SopsContent.propTypes = {
  selected: PropTypes.number,
};

export default SopsContent;
